import { Component }           from '@angular/core';
import { StickyBaseComponent } from '@app/core/bases/sticky-base.component';

@Component( {
	selector: 'app-sticky-content',
	templateUrl: './sticky-content.component.html',
	styleUrls: [ './sticky-content.component.scss' ]
} )
export class StickyContentComponent extends StickyBaseComponent {}
